
import { Component } from "@angular/core";

import { BaseComponent } from "@bt/core/base";

import { NgbModal,NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {  Input } from '@angular/core';
import { faExclamationCircle, faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'confirm-modal',
  templateUrl:"confirm.modal.html",
  styleUrls: ["./confirm.modal.scss"]
})
export class ConfirmModalContent {

  faExclamationCircle = faExclamationCircle;
  faTimes = faTimes;
  
  @Input() isNeedConfirm : boolean;
  @Input() description : string;
  @Input() title : string;
  @Input() btnText : string;
 
  constructor(public activeModal: NgbActiveModal) {}

  public confirm(){
    this.isNeedConfirm=true;
    this.activeModal.close(this.isNeedConfirm)
  }

}


// WEBPACK FOOTER //
// ./src/app/finance/confirm-modal/confirm.modal.ts